<ng-container [formGroup]="contactForm">
    <h3 class="form-header" mat-dialog-titlei18n>Delink Point of Contact for the Ship From Address</h3>

    <div class="grid" style="margin-left: 20px;">

        <div class="row">
            <div fxFlex="50">
                <tsl-select formControlName="contacts" multiple>
                    <tsl-option *ngFor="let option of contactList" [value]="option">
                        <span> {{ option.name}}, {{ option.phone}}, {{ option.email}}</span> 
                    </tsl-option>
                </tsl-select>
            </div>
        </div>
        
    </div>

    <br>

    <!-- Action Buttons -->
    <div class="right">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@d7b35c384aecd25a516200d6921836374613dfe7" t="d7b35c384aecd25a516200d6921836374613dfe7">Cancel</button>
        <button tsl-button size="small" color="blue" filled [disabled]="contactForm.invalid" (click)="save()"
            i18n="@@DeLink" t="DeLink">DeLink</button>
    </div>
</ng-container>